import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { ApplicationSettingsService } from 'src/app/core/application-settings/application-settings.service';
import { ROUTES } from '../constants/routes';
import { UserProfile } from '../models/user-profile';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({
    providedIn: 'root'
})
export class UserProfileCheckGuard {

    private readonly PATHS_ALOWED_PROFILES = new Map<string, string[]>([
        [ROUTES.ADMIN_ORDER_FOFRM_LIST_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_CALENDRIER_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_EXCLUDED_DEMAND_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_NETTING_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_PROJECTS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_DOMAINES_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_APPS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_CONTACTS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_IMPORT_PATH, [UserProfile.ADMIN]],
        [ROUTES.ADMIN_NETTING_SCHEMA_PATH, [UserProfile.ADMIN,  UserProfile.MANAGER_CDS]],
        [ROUTES.ADMIN_NETTING_PRELEVEMENT_PATH, [UserProfile.ADMIN,  UserProfile.MANAGER_CDS]],
        [ROUTES.DATA_PACK_GEN_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.ADMIN_SETTINGS_PATH, [UserProfile.ADMIN]],
        [ROUTES.ADMIN_FEB_LOCATIONS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_FEB_ACTIVITE_UO_NOMENCLATURE_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_UO_EVALUATION_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_CATEGORIE_EVALUATION_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_COMPETENCE_EVALUATION_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_CENTRE_COMPETENCE_PATH , [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_COLLABORATEURS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],
        [ROUTES.ADMIN_POSTES_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER]],

        [ROUTES.FICHE_EXPRESSION_BESOIN_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS, UserProfile.CP_CDS, UserProfile.CP_SNCF]],
        [ROUTES.DEVIS_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS, UserProfile.CP_CDS,UserProfile.SERVICE_MANAGER,UserProfile.CP_SNCF]],
        [ROUTES.EVALUATION_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS, UserProfile.CP_CDS,UserProfile.SERVICE_MANAGER,UserProfile.CP_SNCF]],
        [ROUTES.EVALUATION_TABLE_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS, UserProfile.CP_CDS,UserProfile.SERVICE_MANAGER,UserProfile.CP_SNCF]],
        [ROUTES.DEVIS_VALIDATION_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_SNCF]],
        [ROUTES.AUDIT_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.MANAGER_CDS, UserProfile.CP_CDS, UserProfile.CP_SNCF]],
        [ROUTES.SM_PROJECT_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_ALERT_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_MENU_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_ORDERS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_APPS_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.DASHBOARD_NETTINGS_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS, UserProfile.CP_CDS]],
        [ROUTES.DASHBOARD_POWER_BI_PATH, [UserProfile.ADMIN, UserProfile.SERVICE_MANAGER, UserProfile.CP_CDS, UserProfile.CP_SNCF, UserProfile.MANAGER_CDS, UserProfile.GUEST_CDS, UserProfile.GUEST_SNCF]],
        [ROUTES.FACTURATION_LIST_PATH, [UserProfile.ADMIN]],
        [ROUTES.FACTURATION_IMPORT_PATH, [UserProfile.ADMIN]],
        [ROUTES.FACTURATION_PATH, [UserProfile.ADMIN]],
        [ROUTES.FACTURATION_NETTING_PATH, [UserProfile.ADMIN]],
        [ROUTES.FACTURATION_VUE_NETTING_PATH, [UserProfile.ADMIN, UserProfile.MANAGER_CDS, UserProfile.CP_CDS]]
    ]);

    constructor(private router: Router,
        private applicationSettingsService: ApplicationSettingsService,
        private currentUserService: CurrentUserService) {
    }


    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean {

        const user = this.currentUserService.getCurrentUser();
        const path: string = route.routeConfig!.path ?? '';
        const alowedProfiles = this.PATHS_ALOWED_PROFILES.get(path);
        // Règles générales des profils autorisées
        if (user?.role && alowedProfiles && alowedProfiles.includes(user.role)) {

            // Règles spéciales aux chemins
            if (path == ROUTES.DATA_PACK_GEN_PATH && user.role != UserProfile.ADMIN && !this.applicationSettingsService.getApplicationSettings().enableCollectedDataTab) {
                this.router.navigateByUrl(`/${ROUTES.CORE_PATH}/${ROUTES.NOT_FOUND_PATH}`);
                return false;
            }

            // Accès au centre de service (FEB + Devis) conditionné par Enable_Centre_Service
            const FEB_PATHS = new Set([
                ROUTES.FICHE_EXPRESSION_BESOIN_PATH,
                ROUTES.DEVIS_PATH,
                ROUTES.DEVIS_VALIDATION_PATH,
                ROUTES.ADMIN_FEB_LOCATIONS_PATH,
                ROUTES.ADMIN_FEB_ACTIVITE_UO_NOMENCLATURE_PATH
            ]);
            if (FEB_PATHS.has(path) && !this.applicationSettingsService.getApplicationSettings().Enable_Centre_Service) {
                this.router.navigateByUrl(`/${ROUTES.CORE_PATH}/${ROUTES.NOT_FOUND_PATH}`);
                return false;
            }

            return true;
        } else {
            this.router.navigateByUrl(`/${ROUTES.CORE_PATH}/${ROUTES.NOT_FOUND_PATH}`);
            return false;
        }

    }
}
